<template>
	<div id="page">

		<div class="page-content">
			<div class="fixed-top-box">
				<div class="page-title page-title-small">
					<h2>
						<!--<button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>-->
						یادداشت ها
						<!--<button data-menu="HelpMenu" class="position-static mr-1"><i class="fa fa-question-circle helpIco"></i></button>-->
					</h2>
					<button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
					<button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
				</div>
				<div class="card header-card shape-rounded" data-card-height="100">
					<div class="card-overlay bg-highlight opacity-95"></div>
					<div class="card-overlay dark-mode-tint"></div>
				</div>
				<div class="card card-style mb-2">
					<div class="p-3 d-flex">
						<button id="filterBtn" type="button" class="btn btn-xs rounded-m brand-bg-color ml-1" data-toggle="modal" data-target="#searchModal" style="max-height:31px!important">
							<i class="fa fa-filter text-white"></i>
						</button>
						<div class="filter-row-scrollable">
							<div id="All" @click="lstFilter(null)" class="filterSelectItem selected filter-scrollable-box">همه</div>
							<div @click="lstFilter(item.taskNoteTypeId)" v-for="item in TaskNoteTypeList" :key="item.taskNoteTypeId" :id="item.taskNoteTypeId" class="filterSelectItem filter-scrollable-box">{{ item.title}}</div>
						</div>
					</div>
				</div>
			</div>
			<span data-menu="menu-language" class="optionMenu"></span>
			<div class="main-content-box">
				<div class="card card-style mb-2" @click.prevent="openDetails(task.noteId)" v-for="task in TaskNoteList" :key="task.noteId">
					<div class="list-group list-custom-small list-icon-0" style="border-radius: 15px !important; border-right: 15px solid" :style="{ 'border-color': task.color }">
						<div class="list-group-div py-2 px-3">
							<div>
								<b class="font-13 text-dark">{{task.title}}</b>
							</div>
							<div class="d-flex justify-content-between">
								<div class="text-muted d-inline-block" style="width:90%">
									<span class="ltr ml-0">{{task.createDateTime}}</span>
									<span class="mr-2">نوع: {{task.taskNoteTypeTitle}}</span>
								</div>
								<span class="text-left" @click.stop="showMenu(task)" style="width:10%"><i class="fa fa-ellipsis-v font-14 ml-0"></i></span>
							</div>
						</div>
					</div>
				</div>

				<div class="card card-style" v-if="Loading==false && NoMoreData==false && TaskNoteList.length>0 && TaskNoteList.length%10==0">
					<div class="content">
						<div class="d-flex justify-content-center w-100">
							<button class="btn btn-outline-info rounded-m" @click="getNextPageForTaskNoteList">نمایش بیشتر</button>
						</div>
					</div>
				</div>

				<div class="card card-style" v-if="TaskNoteList.length==0 && Loading==false">
					<div class="content">
						<div class="text-center"><i class="fa fa-exclamation-triangle text-warning fa-3x"></i></div>
						<p class="text-center py-3">یادداشتی یافت نشد.</p>
					</div>
				</div>
			</div>
		</div>
		<transition enter-active-class="animated bounceInUp" leave-active-class="animated bounceOutDown">
			<div v-show="pageLoaded==true" class="addBtn" id="addBtn" ref="addBtn">
				<router-link to="/CreateTaskNote">
					<div class="icon icon-m rounded-m color-white bg-green2-light">
						<i class="fa fa-plus"></i>
					</div>
				</router-link>
			</div>
		</transition>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="pageLoading==true" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید...</div>
			</div>
		</transition>
		<div id="menu-language" class="menu menu-box-bottom menu-box-detached rounded-m" data-menu-effect="menu-over" style="display: block;">
			<div class="m-3">
				<div class="list-group list-custom-small">
					<router-link :to="{ name: 'EditTaskNote', params: { noteId: selectedWorkId  } }" class="d-flex justify-content-between align-items-center"><span><i class="fa fa-search color-green2-light float-right font-14"></i>مشاهده</span><i class="fa fa-angle-left"></i></router-link>
					<button @click="Share" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-share-alt text-warning float-right font-14"></i>اشتراک گذاری</span><i class="fa fa-angle-left"></i></button>
					<button @click="copyTaskNote" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-copy color-magenta2-dark float-right font-14"></i>کپی</span><i class="fa fa-angle-left"></i></button>
					<button @click="AddPin" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-thumbtack color-blue2-light float-right font-14"></i>نشان کردن</span><i class="fa fa-angle-left"></i></button>

					<button @click="deleteTaskNote" class="d-flex justify-content-between align-items-center bg-white p-0"><span class="d-inline-flex align-items-center"><i class="fa fa-trash color-red1-light float-right font-14"></i>حذف</span><i class="fa fa-angle-left"></i></button>

				</div>
				<div class="clear"></div>
			</div>
		</div>
		<Help-Menu title="معرفی اپلیکیشن تسکینو" keyEn="TaskList" v-if="isKarnegasht==false"></Help-Menu>
		<Help-Menu title="معرفی اپلیکیشن کارنگاشت" keyEn="TaskList" v-if="isKarnegasht==true"></Help-Menu>
		<transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
			<div v-if="Loading" class="w-100 d-flex justify-content-center loadingBox">
				<div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
			</div>
		</transition>
	</div>
	<div id="searchModal" class="modal fade" role="dialog">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header align-items-center">
					<h4 class="modal-title mt-0">جستجو</h4>
					<button type="button" class="close" data-dismiss="modal">&times;</button>
				</div>
				<div class="modal-body m-0">

					<div class="w-100 search-box rounded-m position-relative mb-3">
						<i class="fa fa-search pr-3"></i>
						<input type="text" class="border-0" placeholder="جستجو ..." data-search="" v-model="searchKey">
					</div>
					<myTeamList txtPlaceholder="کاربران" class="mb-3" @selectUser="selectUser"></myTeamList>

					<projects class="mb-3" @selectProject="selectProject"></projects>
					<calendar-filter class="filterCalendar" @selectDate="selectDate"></calendar-filter>

					<button type="button" class="btn btn-xxs mt-3 btn-full bg-green1-dark rounded-sm font-900 w-100" data-dismiss="modal" @click="filterList">
						<i class="fa fa-search ml-2"></i>
						جستجو
					</button>
				</div>
			</div>
		</div>
	</div>


</template>

<script>
	import VueSimpleAlert from "vue3-simple-alert";
	import ProjectList from '../Components/ProjectList.vue';
	import MyTeamList from '../Components/MyTeamList.vue';
	import calendarFilter from '../Components/CalendarFilter.vue';
	import HelpMenu from '../Components/HelpMenu.vue';
	export default {
		components: {
			"Help-Menu": HelpMenu,
			"projects": ProjectList,
			"calendar-filter": calendarFilter,
			"myTeamList": MyTeamList,
		},
		data() {
			return {
				page: 1,
				filterId: 0,
				searchKey: "",
				taskNoteTypeId: null,
				projectId: null,
				userId: null,
				selectedWorkId: 0,
				selectedTitle: 0,
				date: null,
				pageLoaded: false,
				pageLoading: false
			};
		},
		computed: {
			TaskNoteTypeList() {
				return this.$store.getters.GetTaskNoteTypeList;
			},
			TaskNoteList() {
				return this.$store.getters.GetTaskNoteList;
			},
			Loading() {
				return this.$store.getters.GetLoading;
			},
			NoMoreData() {
				return this.$store.getters.GetTaskNoteNoMoreData;
			},
			UpdateTaskNoteList() {
				return this.$store.getters.GetUpdateTaskNoteList;
			},
		},

		created() {
			this.filterList();
			this.$store.dispatch("GetTaskNoteTypeListFromServer");
		},
		methods: {
			selectDate(d) {
				this.date = d;
			},
			selectProject(d) {
				this.projectId = d;
			},
			selectUser(d) {
				this.userId = d;
			},
			showAddButton() {
				this.pageLoaded = true;
			},
			showMenu(n) {
				this.selectedWorkId = n.noteId;
				this.selectedTitle = n.title;
				document.getElementsByClassName("optionMenu")[0].click();
			},
			lstFilter(id) {
				this.taskNoteTypeId = id;
				if (id == null) {
					id = "All";
				}
				var elements = document.getElementsByClassName('filterSelectItem');
				for (var i = 0; i < elements.length; i++) {
					elements[i].classList.remove('selected');
				}
				document.getElementById(id).classList.add('selected');
				this.filterList();
			},
			filterList() {
				this.page = 1;
				this.$store.dispatch("GetTaskNoteListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					taskNoteTypeId: this.taskNoteTypeId,
					userId: this.userId,
					date: this.date,
					projectId: this.projectId,
					searchKey: this.searchKey
				});
			},
			copyTaskNote() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm("آیا مایل به ثبت یک کپی از این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.pageLoading = true;
					setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)

					this.$http.get("TaskNote/CopyTaskNote?id=" + this.selectedWorkId)
						.then(data => {
							var res = data.data;
							if (!isNaN(res)) {
								this.$router.push({ name: 'EditTaskNote', params: { noteId: res } });
							}
							else {
								this.showErrorMessage(res);
							}
							this.pageLoading = false;

						});
				});
			},
			Share() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm("آیا مایل به اشتراک گذاری این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.pageLoading = true;
					setTimeout(function () { document.getElementsByClassName('menu-hider')[0].click(); }, 200)
					var data = {
						shareDoc: 1,
						id: this.selectedWorkId
					};
					this.$http.post("TaskNote/ShareDoc", data)
						.then(data => {
							this.pageLoading = false;
							var res = data.data;
							if (res.isSuccess) {
								window.open(res.obj, '_blank');
							} else {
								this.showErrorMessage(res.message);
							}
						});

				});
			},
			deleteTaskNote() {
				document.getElementsByClassName('menu-hider')[0].click();
				VueSimpleAlert.confirm("آیا مایل به حذف این یادداشت هستید؟", null, "question", { confirmButtonText: "تایید", cancelButtonText: "انصراف" }).then(() => {
					this.$http.get("TaskNote/DeleteTaskNote?id=" + this.selectedWorkId)
						.then(data => {
							var res = data.data.toString();
							if (res === "1") {
								this.showSuccessMessage("با موفقیت حذف شد.");
								this.page = 0;
								this.getNextPageForTaskNoteList();

							}
							else {
								this.showErrorMessage(res);
							}


						});
				});
			},
			openDetails(noteId) {
				this.$router.push({ name: 'EditTaskNote', params: { noteId: noteId } });
				document.getElementsByClassName('menu-hider')[0].click();
			},
			getNextPageForTaskNoteList() {

				this.page++;
				this.$store.dispatch("GetTaskNoteListFromServer", {
					pageId: this.page,
					filterId: this.filterId,
					taskNoteTypeId: this.taskNoteTypeId,
					userId: this.userId,
					projectId: this.projectId,
					date: this.date,
					searchKey: this.searchKey
				});
			},
			AddPin() {
				document.getElementsByClassName("menu-hider")[0].click();
				VueSimpleAlert.confirm(
					"آیا مایل به نشان کردن این مورد هستید؟",
					null,
					"question",
					{ confirmButtonText: "تایید", cancelButtonText: "انصراف" }
				).then(() => {

					this.$store.dispatch("AddPin", {
						baseDocId: 28,
						docId: this.selectedWorkId,
						description: this.selectedTitle
					});
				});

			},
			pauseVid(id) {
				if (id != null) {
					var vid = document.getElementById(id);
					vid.pause();
				}
			},
			pauseAllVid() {
				document.querySelectorAll('video').forEach(vid => vid.pause());
			},
		},
		activated() {
			this.showAddButton();
			if (this.UpdateTaskNoteList == true) {
				this.page = 0;
				this.getNextPageForTaskNoteList();
			}

		},
		mounted() {
			this.showAddButton();
			document.querySelectorAll(".menu-box-right").forEach(a => a.style.display = "block");
		}
	};
</script>
